import React from 'react';
import { cn } from '@bem-react/classname';
import { Transition, CSSTransition } from 'react-transition-group';
import PropTypes from 'prop-types';

import './modal.scss';
import { IS_SERVER } from '../../../common';

/**
 * Модальное окна
 *
 * @param {Object} props
 * @param {String} props.dir='' Направление написания правил в исключительных случаях:
 * например, когда для локали ir / ae приходят правила на английском
 * (справа налево для текста правил меняется на слева направо)
 * @param {String} props.title='' Заголовок модального окна
 * @param {Boolean} props.visible Начальное состояние модального окна, true - открыто, false - закрыто
 * @param {Boolean} props.withHeader=true Нужно ли выводить в модальном окне header для title, true - нужно, false - не нужно
 * @param {Function} props.onClose Функция, срабатывающая при закрытии модального окна
 * @param props.children Контент модального окна
 * @param {String} props.className Дополнительные классы для модального окна и его элементов
 * @returns {JSX.Element|null}
 * @constructor
 */
//TODO переделать classname (Эрик)
const Modal = ({
  langId,
  dir,
  title,
  subtitle,
  visible,
  withHeader,
  onClose,
  children,
  className,
  isEuro2024 = false,
}) => {
  const propsClass = cn(className ? className : '');

  const duration = 150;

  const defaultStyle = {
    transition: `opacity ${duration}ms ease-in-out`,
    opacity: 0,
  };

  const transitionStyles = {
    entering: { opacity: 0 },
    entered: { opacity: 1 },
    exiting: { opacity: 0 },
    exited: { opacity: 0 },
  };

  const closeHandler = (e) => {
    if (
      e.target.classList.contains('modal-overlay') ||
      e.target.classList.contains('modal-window__close')
    ) {
      onClose();
    }
    !IS_SERVER && document.querySelector('html').classList.remove('lock-window');
  };

  return (
    <CSSTransition
      in={visible}
      timeout={duration}
      mountOnEnter
      unmountOnExit
      classNames="modal-environment"
    >
      {(state) => (
        <div
          style={{
            ...defaultStyle,
            ...transitionStyles[state],
          }}
        >
          <div
            dir={dir}
            className={`${propsClass()} modal-overlay`}
            onClick={(e) => closeHandler(e)}
          >
            <div className={`${propsClass()} modal-window`}>
              {withHeader && (
                <div
                  className={`${propsClass()} ${
                    isEuro2024 ? 'modal-window__header--euro' : 'modal-window__header'
                  } `}
                >
                  {title} <span className="title-span">{subtitle}</span>
                  <div
                    className={`${propsClass()} modal-window__close`}
                    onClick={(e) => closeHandler(e)}
                  >
                    <svg
                      width="8"
                      height="9"
                      viewBox="0 0 8 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.416016 8.82422C0.363932 8.82422 0.311849 8.81445 0.259766
                  8.79492C0.214193 8.77539 0.16862 8.74609 0.123047 8.70703C0.0449219 8.62891 0.00585938 8.53451 0.00585938 8.42383C0.00585938 8.30664 0.0449219 8.20573 0.123047 8.12109L7.29102 0.962891C7.36914 0.878255 7.46354 0.835938 7.57422 0.835938C7.69141 0.835938 7.79232 0.878255 7.87695 0.962891C7.95508 1.04102 7.99414 1.13867 7.99414 1.25586C7.99414 1.36654 7.95508 1.46094 7.87695 1.53906L0.708984 8.70703C0.669922 8.74609 0.624349 8.77539 0.572266 8.79492C0.520182 8.81445 0.468099 8.82422 0.416016 8.82422ZM7.58398 8.82422C7.5319 8.82422 7.47982 8.81445 7.42773 8.79492C7.37565 8.77539 7.33008 8.74609 7.29102 8.70703L0.123047 1.53906C0.0449219 1.46094 0.00585938 1.36654 0.00585938 1.25586C0.00585938 1.13867 0.0449219 1.04102 0.123047 0.962891C0.207682 0.878255 0.305339 0.835938 0.416016 0.835938C0.533203 0.835938 0.630859 0.878255 0.708984 0.962891L7.87695 8.12109C7.95508 8.20573 7.99414 8.30664 7.99414 8.42383C7.99414 8.53451 7.95508 8.62891 7.87695 8.70703C7.83138 8.74609 7.78255 8.77539 7.73047 8.79492C7.6849 8.81445 7.63607 8.82422 7.58398 8.82422Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                </div>
              )}

              {isEuro2024 && (
                <div
                  style={{
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    borderRadius: '100%',
                    marginRight: '5px',
                  }}
                  className={`${propsClass()} modal-window__close`}
                  onClick={(e) => closeHandler(e)}
                >
                  <svg
                    width="8"
                    height="9"
                    viewBox="0 0 8 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.416016 8.82422C0.363932 8.82422 0.311849 8.81445 0.259766
              8.79492C0.214193 8.77539 0.16862 8.74609 0.123047 8.70703C0.0449219 8.62891 0.00585938 8.53451 0.00585938 8.42383C0.00585938 8.30664 0.0449219 8.20573 0.123047 8.12109L7.29102 0.962891C7.36914 0.878255 7.46354 0.835938 7.57422 0.835938C7.69141 0.835938 7.79232 0.878255 7.87695 0.962891C7.95508 1.04102 7.99414 1.13867 7.99414 1.25586C7.99414 1.36654 7.95508 1.46094 7.87695 1.53906L0.708984 8.70703C0.669922 8.74609 0.624349 8.77539 0.572266 8.79492C0.520182 8.81445 0.468099 8.82422 0.416016 8.82422ZM7.58398 8.82422C7.5319 8.82422 7.47982 8.81445 7.42773 8.79492C7.37565 8.77539 7.33008 8.74609 7.29102 8.70703L0.123047 1.53906C0.0449219 1.46094 0.00585938 1.36654 0.00585938 1.25586C0.00585938 1.13867 0.0449219 1.04102 0.123047 0.962891C0.207682 0.878255 0.305339 0.835938 0.416016 0.835938C0.533203 0.835938 0.630859 0.878255 0.708984 0.962891L7.87695 8.12109C7.95508 8.20573 7.99414 8.30664 7.99414 8.42383C7.99414 8.53451 7.95508 8.62891 7.87695 8.70703C7.83138 8.74609 7.78255 8.77539 7.73047 8.79492C7.6849 8.81445 7.63607 8.82422 7.58398 8.82422Z"
                      fill="black"
                    />
                  </svg>
                </div>
              )}

              <div
                style={
                  isEuro2024
                    ? {
                        backgroundColor: '#fff',
                        borderRadius: '20px',
                        padding: '10px 2px 10px 5px',
                      }
                    : {}
                }
              >
                <div className={`${propsClass()} modal-window__body`}>{children}</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </CSSTransition>
  );
};

Modal.propTypes = {
  title: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  withHeader: PropTypes.bool,
};

Modal.defaultProps = {
  title: '',
  withHeader: true,
};

export default Modal;
